import type { NextPage } from 'next';
import { Page as Component } from '~/components/specifics/vendors/messages/Page';
import { NskHead } from '~/components/common/head/NskHead';

export const PATH = '/vendors/messages';

const Home: NextPage = () => (
  <>
    <NskHead title="チャット" />
    <Component />
  </>
);

export default Home;
